import { styled, css } from '@creditas-ui/react';

const skeletonAnimation = css`
  background-color: #e0e0e0;
  animation: skeleton-loading 1.5s infinite ease-in-out;

  @keyframes skeleton-loading {
    0% {
      background-color: #e0e0e0;
    }
    50% {
      background-color: #f0f0f0;
    }
    100% {
      background-color: #e0e0e0;
    }
  }
`;

const Container = styled.div<{ show?: boolean }>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  min-height: 100vh;
  background: #f5f5f5;
`;

const SidebarSkeleton = styled.div`
  width: 250px;
  padding: 16px;
  background: #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SidebarItem = styled.div`
  height: 20px;
  width: 80%;
  border-radius: 4px;
  ${skeletonAnimation}
`;

const Content = styled.div`
  flex: 1;
  padding: 24px;
`;

const HeaderSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const TitleSkeleton = styled.div`
  height: 24px;
  width: 200px;
  border-radius: 4px;
  ${skeletonAnimation}
`;

const ButtonSkeleton = styled.div`
  height: 40px;
  width: 150px;
  border-radius: 8px;
  ${skeletonAnimation}
`;

const FiltersSkeleton = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

const FilterItem = styled.div`
  height: 40px;
  width: 150px;
  border-radius: 8px;
  ${skeletonAnimation}
`;

const TableSkeleton = styled.div`
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

const TableRow = styled.div`
  height: 48px;
  border-radius: 4px;
  margin-bottom: 8px;
  ${skeletonAnimation}
`;

const isObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value);

const Skeleton = ({ show }) => {
  const resolvedShow = isObject(show) ? show.show : show;

  return (
    <Container show={resolvedShow}>
      <SidebarSkeleton>
        <SidebarItem />
        <SidebarItem />
        <SidebarItem />
        <SidebarItem />
      </SidebarSkeleton>

      <Content>
        <HeaderSkeleton>
          <TitleSkeleton />
          <ButtonSkeleton />
        </HeaderSkeleton>

        <FiltersSkeleton>
          <FilterItem />
          <FilterItem />
          <FilterItem />
        </FiltersSkeleton>

        <TableSkeleton>
          {[...Array(5)].map((_, i) => (
            <TableRow key={i} />
          ))}
        </TableSkeleton>
      </Content>
    </Container>
  );
};

export { Skeleton };
